<template>
  <div>
    <div :class="['d-flex col-12 col-md-auto px-0 mb-3', Object.keys(options.filter).length > 1 ? 'mb-md-2' : 'mb-md-0']" v-for="(filterOption, filterKey) in options.filter" :key="filterKey">
      <label for="filter" class="sr-only">Filter</label>
      <div class="filter">
        <div class="form-check pl-0" v-for="(filterOptionOption, childIndex) in filterOption" :key="childIndex" v-if="$store.state.showExpand ? childIndex < 5 : true">
          <input class="form-check-input" type="radio" :name="'show' + filterKey" :id="'show' + filterOptionOption.name + filterKey" @change="$emit('setFilter', {filterKey: filterKey, filterChosen: filterOptionOption.value })" :value="filterOptionOption.value" :checked="activeFilter[filterKey] === filterOptionOption.value">
          <label class="form-check-label" :for="'show' + filterOptionOption.name + filterKey">{{filterOptionOption.name}}</label>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['options', 'activeFilter']
}
</script>



// WEBPACK FOOTER //
// src/components/DataTableFields/Filter.vue